import styled from "styled-components";
import Screens from "screens";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .box {
    ${({ type }) => !type && `background-color: transparent;`}
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    @media ${Screens.mobile}, ${Screens.tablet} {
      width: 100%;
      margin-top: 20px;
    }
    .panel {
      .error {
        color: red;
        margin: 15px 0 15px 0;
      }
      .selectType {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        .actions {
          width: fit-content;
          margin-bottom: 10px;
          @media ${Screens.mobile}, ${Screens.tablet} {
            .publishJobAd {
              margin-top: -5px;
            }
          }
        }
        .label {
          margin-bottom: 20px;
        }
        text-align: center;
        .action {
          margin-top: 20px;
        }
      }
      .submit {
        margin-top: 30px;
      }
      .bottomSection {
        display: flex;
        flex-direction: row;
        margin-top: 15px;
        justify-content: space-between;
      }
      .file {
        margin-top: 20px;
      }
    }
  }
`;
